import { Link, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ADMIN, ALWAYZ, COUPANG, ESM, KAKAO, TOSS } from '../../../../common/common.constants';

import Container from '../../atoms/Container';
import Swal from 'sweetalert2';
import { axiosCustom } from 'common/common.function';
import { useEffect, useState } from 'react';
import { IUserInfo, WakeUp } from 'common/interface/props';

const HeaderWrap = styled.header`
  background-color: #fff; //배경색상
  width: 100%; //가로 넓이
  height: 80px; // 세로 높이
  border-bottom: 1px solid #ddd; //헤더 밑줄긋기
  position: fixed; //스크롤 내려도 고정되있음(바디 장악하니 주의할것)
  z-index: 999; //position을 주면 z-index 높이가 생긴다.
  top: 0;
`;

const HeaderContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0;

  > nav {
    > a,
    button {
      font-weight: 500;
      color: ${({ theme }) => theme.pltoColor};
      padding: 8px 15px;
      background-color: transparent;
      cursor: pointer;

      &:last-child {
        border: 1px solid ${({ theme }) => theme.pltoColor};
        border-radius: 30px;
      }
    }
  }
`;

export default function Header() {
  const { pathname } = useLocation();

  const navigate = useNavigate();
  const location = useLocation();

  // solType
  const [solType, setSolType] = useState('');

  // 로그인 여부
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // 로그인 여부 체크 (주소가 바뀔때마다)
  useEffect(() => {
    // WakeUp 서비스 확인
    setSolType(
      [`ADMIN`, `COUPANG`, 'ST11', 'KAKAO', 'ALWAYZ', 'ESM', 'TOSS', 'ALL'].includes(location.pathname.split('/')[1].toUpperCase())
        ? location.pathname.split('/')[1].toUpperCase()
        : '',
    );

    // 로그인 정보 가져오기
    const rawUserInfo = sessionStorage.getItem('userInfo');

    // 로그인 데이터 파싱
    const userInfo: IUserInfo = rawUserInfo && JSON.parse(rawUserInfo);

    userInfo ? setIsLoggedIn(true) : setIsLoggedIn(false);
  }, [location]);

  // useEffect(() => {
  //   if (location.pathname !== '/coupang/admin' && solType === 'COUPANG') {
  //     window.location.href = 'https://engapi-coupang.playauto.co.kr';
  //   }
  // }, [solType]);

  // 로그아웃
  async function checkLogout() {
    const confirm = await Swal.fire({
      title: '확인',
      text: '로그아웃하시겠습니까?',
      showConfirmButton: true,
      showCancelButton: true,
    });

    if (confirm.isConfirmed) {
      //Cookie에 jwt Token 삭제 API 호출
      let logoutResult;
      // if (solType && checkUseSpringSolType(solType as WakeUp)) {
      //   logoutResult = await axiosCustom.post(`${process.env.REACT_APP_NEW_BACKEND_ENDPOINT}/api/user/logout`);
      // } else {
      logoutResult = await axiosCustom.post(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/user/logout`);
      // }

      if (logoutResult.success) {
        setIsLoggedIn(false);

        sessionStorage.removeItem('userInfo'); //로그인 정보 세션스토리지 초기화
        sessionStorage.removeItem('wakeupInfo');
        sessionStorage.removeItem('addressSeq'); // 11번가 주소록 세션스토리지 초기화

        // 마이페이지에서 로그아웃할 때는 로그인 페이지로 로드할 것
        if (location.pathname.includes('/my-page')) {
          navigate(`/${solType.toLowerCase()}/member/login`);
        } else {
          navigate(`/${solType.toLowerCase()}/member/create-account`);
        }
      }
    }
  }

  // 가이드 URL 매핑
  const guideUrlMap: Record<string, string> = {
    [COUPANG]: 'wakeup_coupang',
    [ALWAYZ]: 'wakeup_alwayz',
    [ESM]: 'wakeup_esm',
    [KAKAO]: 'wakeup_kakao',
    [TOSS]: 'wakeup_toss',
  };

  // 가이드가 있는 solType 목록
  const solTypesWithGuide = [COUPANG, ALWAYZ, ESM, KAKAO, TOSS];

  // 헤더 메뉴 렌더링 (로그인/로그아웃/회원가입/가이드/마이페이지 로드)
  const renderHeaderMenu = () => {
    const hasGuide = solTypesWithGuide.includes(solType as WakeUp);
    const guideUrl = guideUrlMap[solType];

    // 1. ADMIN 일 때 없음
    if (solType === ADMIN) {
      return null;
    }

    // 2. 가이드가 있을 때 가이드버튼
    if (hasGuide && guideUrl) {
      const guideLink = `${process.env.REACT_APP_FRONTEND_ENDPOINT}/guide/${guideUrl}`;
      const isCreateAccountPage = pathname.includes('/member/create-account');
      const basePath = `/${solType.toLowerCase()}`;

      if (!isLoggedIn) {
        // 비로그인 상태
        return (
          <>
            <a href={guideLink} target="_blank" rel="noreferrer">
              사용 가이드 보러가기
            </a>
            {isCreateAccountPage ? <Link to={`${basePath}/member/login`}>로그인</Link> : <Link to={`${basePath}/member/create-account`}>회원가입</Link>}
          </>
        );
      } else {
        // 로그인 상태
        return location.pathname.includes('/st11/my-page') ? (
          <></>
        ) : (
          <>
            {/* <Link to={`/admin/dashboard`}>연동 관리</Link> */}
            <a href={guideLink} target="_blank" rel="noreferrer">
              사용 가이드 보러가기
            </a>
            <button type="button" onClick={checkLogout}>
              로그아웃
            </button>
          </>
        );
      }
    } else {
      // 가이드가 없는 solType
      const basePath = `/${solType.toLowerCase()}`;
      if (!isLoggedIn) {
        // 비로그인 상태
        return (
          <>
            <Link to={`${basePath}/member/login`}>로그인</Link>
            <Link to={`${basePath}/member/create-account`}>회원가입</Link>
          </>
        );
      } else {
        // 로그인 상태
        return location.pathname.includes('/st11/my-page') ? (
          <></>
        ) : (
          <>
            <button type="button" onClick={checkLogout}>
              로그아웃
            </button>
          </>
        );
      }
    }
  };

  return (
    <>
      {solType !== '' && (
        <HeaderWrap>
          <HeaderContainer noBody={true}>
            {/* 로고 */}
            <img src="https://cloud.plto.com/design/logo/logo_main.png" alt="플레이오토 로고" style={{ width: '8.25rem' }} />
            {/* 네비게이션 메뉴 */}
            <nav>{renderHeaderMenu()}</nav>
          </HeaderContainer>
        </HeaderWrap>
      )}
    </>
  );
}
